export const SegmentEvents = {
  USER_CLICKED: "User Clicked",
  USER_INPUTTED: "User Inputted",
} as const;
